import get from 'lodash.get';
import { useCallback, useState } from 'react';

import content from '../content.json';

export const useContent = () => {
  const [value] = useState(content);

  const getContentByPath = useCallback(
    <T,>(path: string): T | string => {
      return get(value, path, '');
    },
    [value],
  );

  return {
    value,
    getContentByPath,
  };
};
